import { Button, CircularProgress, Modal, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { AppContext } from "../../scripts/context/App";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  minHeight: "20vh",
  bgcolor: "#fff",
  borderRadius: "4px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};

interface IProps {
  data: any;
  addNewProject: (data: any) => void;
  setData: (data: any) => void;
  handleClose: () => void;
}

export default function CreateProjectModal({
  data,
  addNewProject,
  setData,
  handleClose,
}: IProps) {
  const { user } = useContext(AppContext);
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState("");
  const handleChange = (e: any) => {
    setData({ [e.target.name]: e.target.value });
  };

  const submitModal = async () => {
    if (!user.permissions.includes("create_project")) return toast.error("You don't have permission to create project");
    if (!data.data.name.trim()) {
      return setError("Name is required");
    }

    setIsCreating(true);
    const { name } = data.data;
    try {
      const { data: createProjectRes } = await axios.post("/smart-contract/create-project", { name });
      addNewProject(createProjectRes.data);
    } catch (error) {
      toast.error(
        "Something went wrong. Please try again later or contact our support team.",
      );

      console.log({ error });
    }

    setIsCreating(false);
    handleClose();
  };

  return (
    <Modal
      keepMounted
      open={data.status}
      onClose={handleClose}
      aria-labelledby="Create-project-Modal"
    >
      <Box sx={style}>
        <Box sx={{ p: 3, borderBottom: "1px solid #d3d3d3" }}>
          <Typography
            variant="h6"
            component="h2"
            sx={{ wordBreak: "break-all" }}
          >
            Add New Project
          </Typography>
        </Box>
        <Box sx={{ p: 3 }}>
          <TextField
            id="name"
            name="name"
            label="Project Name"
            variant="standard"
            value={data.data.name}
            onChange={handleChange}
            fullWidth
            inputProps={{ maxLength: 100 }}

            error={!!error}
            helperText={error}
          />
        </Box>

        <Box
          sx={{
            borderTop: "1px solid #d3d3d3",
            p: 3,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={submitModal}
            disabled={isCreating}
            endIcon={isCreating && <CircularProgress size={20} />}
          >
            {data.edit ? "Edit" : "Create"}
          </Button>
          <Button
            variant="outlined"
            color="error"
            disabled={isCreating}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
